"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FullNameFieldValueGetter = void 0;
const safe_field_value_1 = require("../../safe-field-value");
const get_value_1 = require("./get-value");
const objects_1 = require("../../type-checking/objects");
const primitives_1 = require("../../type-checking/primitives");
const typing_1 = require("../../type-checking/typing");
const get_field_value_1 = require("../../helpers/get-field-value");
class FullNameFieldValueGetter extends safe_field_value_1.BaseFieldValueGetter {
    constructor() {
        super(...arguments);
        this.getFieldValue = (field, record) => {
            const fieldValue = (0, get_field_value_1.getValueFromRecordBySlug)(record, field);
            if (fieldValue === undefined)
                return this.getEmptyValue();
            if (!this.isValidFieldValue(fieldValue))
                return this.getEmptyValue();
            return (0, get_value_1.generateFullNameFieldValue)(field, fieldValue);
        };
        this.isValidFieldValue = (fieldValue) => {
            return (0, objects_1.isValidObjectValue)(fieldValue, {
                first_name: (0, typing_1.Optional)(primitives_1.isStringValue),
                last_name: (0, typing_1.Optional)(primitives_1.isStringValue),
                title: (0, typing_1.Optional)(primitives_1.isStringValue),
                middle_name: (0, typing_1.Optional)(primitives_1.isStringValue),
                sys_root: (0, typing_1.Optional)(primitives_1.isStringValue),
            });
        };
        this.getEmptyValue = () => (0, get_value_1.getFullNameFieldEmptyValue)();
    }
}
exports.FullNameFieldValueGetter = FullNameFieldValueGetter;
